enum PlannerEventType {
  LUNCH = 'LUNCH',
  PAUSED = 'PAUSED',
  PLANNED = 'PLANNED',
  ABSENCE = 'ABSENCE',
  NONPLANNED = 'NONPLANNED',
  INTERNAL = 'INTERNAL',
}

export default PlannerEventType;